'use client';

import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import breakpoints from '@/lib/breakpoints';
import { useMediaQuery } from '@/hooks/useMediaQuery';

import { ArticleObject } from '@/models/Articles';

import Carousel from './Carousel';
import SimpleArticle from '../articles/SimpleArticle';

export type ArticlesCarouselProps = {
  postobjectslist: {
    postobjectitem: ArticleObject;
  }[];
  anchor?: string;
};

export default function ArticlesCarousel(props: ArticlesCarouselProps) {
  const { postobjectslist, anchor } = props;
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints.md})`);
  const [desktop, setDesktop]: [
    boolean | undefined,
    Dispatch<SetStateAction<boolean | undefined>>,
  ] = useState();

  useEffect(() => {
    setDesktop(isDesktop);
  }, [isDesktop]);

  return desktop ? (
    <Carousel postobjectslist={postobjectslist} anchor={anchor} />
  ) : (
    <div className='flex flex-col gap-6'>
      {postobjectslist.map((articleObject, index: number) => (
        <SimpleArticle
          key={index}
          title={articleObject?.postobjectitem?.title}
          featuredImage={articleObject?.postobjectitem?.featuredImage}
          data-aos='fade-in'
          data-aos-anchor={anchor || null}
          data-aos-delay={index * 100 + 500}
          slug={`/venture-technologies/${articleObject?.postobjectitem?.slug}`}
        />
      ))}
    </div>
  );
}
